import { Chart, ChartTimerName } from '@frontend/chart/types';

export const PUDO_TRANSACTION_TIMER_PICK_UP_PENDING_WAITING_DAYS_DONUT_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: ChartTimerName.TRANSACTION_PICK_UP_PENDING,
            data: [
                { label: '0', value: 18 },
                { label: '1', value: 7 },
                { label: '2', value: 3 },
                { label: '3', value: 2 },
                { label: '4', value: 1 },
                { label: '5', value: 1 },
                { label: '6', value: 0 }
            ]
        }
    ]
};
